import { useCallback, useEffect, useState } from "react";
import { Check, Trash2 } from "lucide-react";
import { api } from "../../lib/api";

const TYPE_LABELS = { private_event: "Événement privé", customization: "Personnalisation", contact: "Contact" };

export default function AdminInquiries() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/inquiries").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  const markRead = async (id) => { await api.patch(`/admin/inquiries/${id}`); load(); };
  const remove = async (id) => { await api.delete(`/admin/inquiries/${id}`); load(); };

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-serif text-3xl sm:text-4xl text-ink">Demandes</h1>
      <div className="w-16 h-px bg-gold mt-4" />
      <div className="mt-8 space-y-4">
        {items.map((q) => (
          <div key={q.id} data-testid={`inquiry-${q.id.slice(0, 8)}`}
            className={`bg-ivory border rounded-2xl p-6 ${q.read ? "border-champagne opacity-70" : "border-terracotta/50"}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <span className="text-[0.65rem] uppercase tracking-[0.2em] text-clay">{TYPE_LABELS[q.type] || q.type}</span>
                <h3 className="font-serif text-xl text-ink mt-1">{q.name}</h3>
                <p className="text-sm text-earth">{q.email}{q.phone ? ` · ${q.phone}` : ""}</p>
                <p className="text-xs text-earth/60 mt-1">{new Date(q.created_at).toLocaleString("fr-FR")}</p>
              </div>
              <div className="flex gap-2">
                {!q.read && (
                  <button data-testid={`read-inquiry-${q.id.slice(0, 8)}`} onClick={() => markRead(q.id)}
                    className="w-9 h-9 rounded-full border border-champagne flex items-center justify-center text-earth hover:border-olive hover:text-olive transition-colors" title="Marquer comme lu">
                    <Check size={14} />
                  </button>
                )}
                <button data-testid={`delete-inquiry-${q.id.slice(0, 8)}`} onClick={() => remove(q.id)}
                  className="w-9 h-9 rounded-full border border-champagne flex items-center justify-center text-earth hover:border-burgundy hover:text-burgundy transition-colors">
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
            {Object.keys(q.details || {}).filter((k) => q.details[k]).length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {Object.entries(q.details).filter(([, v]) => v).map(([k, v]) => (
                  <span key={k} className="text-xs bg-cream border border-champagne rounded-full px-3 py-1.5 text-earth">
                    <span className="text-ink font-medium">{k}</span> : {v}
                  </span>
                ))}
              </div>
            )}
            {q.message && <p className="mt-4 text-sm text-earth font-light leading-relaxed">{q.message}</p>}
          </div>
        ))}
        {items.length === 0 && <p className="text-earth">Aucune demande pour le moment.</p>}
      </div>
    </div>
  );
}
